import { takeEvery, call, all, put } from 'redux-saga/effects';
import {
    FETCH_MENSTRUAL_CYCLE_DAILY_VIEW,
    FETCH_MENSTRUAL_CYCLE_DAILY_VIEW_FETCHING,
    FETCH_MENSTRUAL_CYCLE_DAILY_VIEW_SUCCESS,
    FETCH_MENSTRUAL_CYCLE_DAILY_VIEW_FAIL,
    UPDATE_USER_MENSTRUAL_CYCLE_SYMPTOMS,
    UPDATE_USER_MENSTRUAL_CYCLE_SYMPTOMS_START,
    UPDATE_USER_MENSTRUAL_CYCLE_SYMPTOMS_SUCCESS,
    UPDATE_USER_MENSTRUAL_CYCLE_SYMPTOMS_ERROR,
    FETCH_MENSTRUAL_CYCLE_SYMPTOMS_ICONS,
    MENSTRUAL_CYCLE_SYMPTOMS_ICONS_FETCHING,
    MENSTRUAL_CYCLE_SYMPTOMS_ICONS_SUCCESS,
    MENSTRUAL_CYCLE_SYMPTOMS_ICONS_ERROR,
    FETCH_MENSTRUAL_CYCLING_TRACKING_SUMMARY,
    FETCH_MENSTRUAL_CYCLING_TRACKING_SUMMARY_FETCHING,
    FETCH_MENSTRUAL_CYCLING_TRACKING_SUMMARY_SUCCESS,
    FETCH_MENSTRUAL_CYCLING_TRACKING_SUMMARY_FAIL,
    FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR,
    FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR_FETCHING,
    FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR_SUCCESS,
    FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR_FAIL,
    SAVE_MENSTRUAL_DATE_CHANGES,
    SAVE_MENSTRUAL_DATE_CHANGES_START,
    SAVE_MENSTRUAL_DATE_CHANGES_SUCCESS,
    SAVE_MENSTRUAL_DATE_CHANGES_FAIL,
    FETCH_MENSTRUAL_CYCLING_TRACKING_REPORTS,
    FETCH_MENSTRUAL_CYCLING_TRACKING_REPORTS_FETCHING,
    FETCH_MENSTRUAL_CYCLING_TRACKING_REPORTS_SUCCESS,
    FETCH_MENSTRUAL_CYCLING_TRACKING_REPORTS_FAIL,
    FETCH_MENSTRUAL_CYCLE_EDUCATIONAL_CONTENT,
    MENSTRUAL_CYCLE_EDUCATIONAL_CONTENT_FETCHING,
    MENSTRUAL_CYCLE_EDUCATIONAL_CONTENT_SUCCESS,
    ONLY_RESET_MENSTRUAL_CYCLING_TRACKING_CALENDAR,
    SAVE_MENSTRUAL_DATE_CHANGES_AND_UPDATE_DAY_VIEW_DATA,
    MENSTRUAL_CYCLE_EDUCATIONAL_CONTENT_ERROR,
    SAVE_MENSTRUAL_CYCLE_INITIAL_SETUP,
    SAVE_MENSTRUAL_CYCLE_INITIAL_SETUP_SUCCESS,
    SAVE_MENSTRUAL_CYCLE_INITIAL_SETUP_FAIL,
    SAVE_MENSTRUAL_CYCLE_INITIAL_SETUP_START,
    FETCH_USER_SETTINGS,
    STARTED_CYCLE_UPDATE_FROM_CALENDAR,
    ENDED_CYCLE_UPDATE_FROM_CALENDAR,
    ENDED_CYCLE_UPDATE_FROM_CALENDAR_FAIL,
    SAVE_OR_CONFIRM_SINGLE_CYCLE,
    SAVE_OR_CONFIRM_SINGLE_CYCLE_END,
    SAVE_OR_CONFIRM_SINGLE_CYCLE_FAIL,
    SAVE_OR_CONFIRM_SINGLE_CYCLE_START,
    UNSET_MENSTRUAL_CYCLE_INITIAL_SETUP,
    UNSET_MENSTRUAL_CYCLE_INITIAL_SETUP_STEP1,
    OPEN_MCT_INITIAL_SETUP_ALL_SET_MODAL,
    UPDATE_USER_SETTINGS_ERROR
} from '../actions/ActionTypes';
import moment from 'moment';
import { DATE_FORMAT } from '../constants/MenstrualCycleTrackingConstants';
import { UPDATE_USER_SETTINGS_SUCCESS, UPDATE_USER_SETTINGS_UPDATING } from 'actions/ActionTypes';
import { gcApi, webApi } from '../config/axios';
import { handlingErrorCallback, handlingSuccessCallback } from './sagasUtils';

// worker
export function* fetchMenstrualCycleDayView(action) {
    try {
        yield put({
            type: FETCH_MENSTRUAL_CYCLE_DAILY_VIEW_FETCHING
        });

        const { date } = action.payload;
        const currentDate = new moment().format(DATE_FORMAT);
        const response = yield call(
            gcApi.get,
            `/periodichealth-service/menstrualcycle/dayview/${date}?todayDate=${currentDate}`
        );

        yield put({
            type: FETCH_MENSTRUAL_CYCLE_DAILY_VIEW_SUCCESS,
            menstrualCycleDayView: response.data,
            menstrualCycleDayViewStatus: response.status
        });
        //this is set so the dayView will not be affected if this fetch is triggered from the calendar
        yield put({
            type: ENDED_CYCLE_UPDATE_FROM_CALENDAR
        });
    } catch (e) {
        yield put({
            type: FETCH_MENSTRUAL_CYCLE_DAILY_VIEW_FAIL,
            menstrualCycleDayView: null
        });
        //this is set so the dayView will not be affected if this fetch is triggered from the calendar
        yield put({
            type: ENDED_CYCLE_UPDATE_FROM_CALENDAR_FAIL
        });
    }
}

// worker
export function* updateUserMenstrualCycleSymptoms(action) {
    try {
        yield put({
            type: UPDATE_USER_MENSTRUAL_CYCLE_SYMPTOMS_START
        });

        const ovulationDayChanged = !!action.payload.ovulationDayChanged;
        delete action.payload.ovulationDayChanged;

        const response = yield call(
            gcApi.post,
            `/periodichealth-service/menstrualcycle/dailylog/${action.payload.calendarDate}`,
            {
                ...action.payload
            }
        );

        yield put({
            type: UPDATE_USER_MENSTRUAL_CYCLE_SYMPTOMS_SUCCESS,
            response
        });

        if (ovulationDayChanged) {
            // If the ovulation day has changed so have the values to the following
            yield call(fetchMenstrualCycleDayView, {
                payload: {
                    date: action.payload.calendarDate
                }
            });
        }
    } catch (e) {
        yield put({
            type: UPDATE_USER_MENSTRUAL_CYCLE_SYMPTOMS_ERROR
        });
    }
}

// worker
export function* fetchMenstrualCycleSymptomsIcons() {
    try {
        yield put({
            type: MENSTRUAL_CYCLE_SYMPTOMS_ICONS_FETCHING
        });

        const response = yield call(webApi.get, `/web-data/menstrual-cycle-tracking/animated-icons.json`);

        yield put({
            type: MENSTRUAL_CYCLE_SYMPTOMS_ICONS_SUCCESS,
            response
        });
    } catch (e) {
        yield put({
            type: MENSTRUAL_CYCLE_SYMPTOMS_ICONS_ERROR
        });
    }
}

//worker
export function* fetchMenstrualCyclingTrackingSummary(action) {
    const { date } = action.payload;

    try {
        yield put({
            type: FETCH_MENSTRUAL_CYCLING_TRACKING_SUMMARY_FETCHING
        });

        const response = yield call(gcApi.get, `/periodichealth-service/menstrualcycle/summary/${date}`);

        yield put({
            type: FETCH_MENSTRUAL_CYCLING_TRACKING_SUMMARY_SUCCESS,
            mctSummary: response.data,
            mctStatus: response.status
        });
    } catch (e) {
        yield put({
            type: FETCH_MENSTRUAL_CYCLING_TRACKING_SUMMARY_FAIL,
            mctSummary: {}
        });
    }
}

export function* fetchMenstrualCyclingTrackingCalendar(action) {
    const { startDate, endDate, isForDeleteAllDatesCheck = false, callback = {} } = action.payload;

    try {
        yield put({
            type: FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR_FETCHING
        });

        const response = yield call(
            gcApi.get,
            `/periodichealth-service/menstrualcycle/calendar/${startDate}/${endDate}`
        );

        yield put({
            type: FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR_SUCCESS,
            menstrualCycleTrackingCalendar: response.data,
            startDate: startDate,
            endDate: endDate,
            isForDeleteAllDatesCheck: isForDeleteAllDatesCheck
        });

        yield call(handlingSuccessCallback, callback, response);
    } catch (e) {
        yield put({
            type: FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR_FAIL,
            menstrualCycleTrackingCalendar: {}
        });

        yield call(handlingErrorCallback, callback, e);
    }
}

export function* updateMenstrualCycleDates(action) {
    try {
        yield put({
            type: SAVE_MENSTRUAL_DATE_CHANGES_START
        });

        const response = yield call(gcApi.post, `/periodichealth-service/menstrualcycle/calendarupdates`, {
            ...action.payload
        });
        yield put({
            type: SAVE_MENSTRUAL_DATE_CHANGES_SUCCESS,
            response
        });
    } catch (e) {
        yield put({
            type: SAVE_MENSTRUAL_DATE_CHANGES_FAIL
        });
    }
}

export function* updateMenstrualCycleDatesAndFetchDayViewData(action) {
    try {
        yield put({
            type: SAVE_MENSTRUAL_DATE_CHANGES_START
        });

        yield put({
            type: STARTED_CYCLE_UPDATE_FROM_CALENDAR
        });

        const response = yield call(gcApi.post, `/periodichealth-service/menstrualcycle/calendarupdates`, {
            ...action.payload
        });

        yield all([
            put({
                type: FETCH_MENSTRUAL_CYCLE_DAILY_VIEW,
                payload: { date: action.fetchDayViewDate }
            }),

            put({
                type: ONLY_RESET_MENSTRUAL_CYCLING_TRACKING_CALENDAR
            }),
            put({
                type: FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR,
                payload: {
                    startDate: moment(action.payload.todayCalendarDate)
                        .startOf('month')
                        .format(DATE_FORMAT),
                    endDate: moment(action.payload.todayCalendarDate)
                        .endOf('month')
                        .format(DATE_FORMAT)
                }
            }),
            put({
                type: FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR,
                payload: {
                    startDate: moment(action.payload.todayCalendarDate)
                        .add(1, 'M')
                        .startOf('month')
                        .format(DATE_FORMAT),
                    endDate: moment(action.payload.todayCalendarDate)
                        .add(1, 'M')
                        .endOf('month')
                        .format(DATE_FORMAT)
                }
            })
        ]);

        //we use this data for six month to check if the user has any remaining cycle, because if he does not we need to warn
        // the user that he will become inactive
        //the api only allow for 3 month at a time so we need two requests
        yield all([
            put({
                type: FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR,
                payload: {
                    startDate: moment()
                        .add(-2, 'month')
                        .startOf('month')
                        .format(DATE_FORMAT),
                    endDate: moment()
                        .endOf('month')
                        .format(DATE_FORMAT),
                    isForDeleteAllDatesCheck: true
                }
            }),
            put({
                type: FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR,
                payload: {
                    startDate: moment()
                        .add(-5, 'month')
                        .startOf('month')
                        .format(DATE_FORMAT),
                    endDate: moment()
                        .add(-3, 'month')
                        .endOf('month')
                        .format(DATE_FORMAT),
                    isForDeleteAllDatesCheck: true
                }
            })
        ]);

        yield put({
            type: SAVE_MENSTRUAL_DATE_CHANGES_SUCCESS,
            response
        });
    } catch (e) {
        yield put({
            type: SAVE_MENSTRUAL_DATE_CHANGES_FAIL
        });
    }
}

export function* fetchMenstrualCyclingTrackingReports(action) {
    const { numberOfCycles, date, next = false, reportType = 'CYCLE' } = action.payload;
    const currentDate = new moment().format(DATE_FORMAT);

    try {
        yield put({
            type: FETCH_MENSTRUAL_CYCLING_TRACKING_REPORTS_FETCHING
        });

        const response = yield call(
            gcApi.get,
            `/periodichealth-service/reports/menstrualcycle/${numberOfCycles}/${date}`,
            {
                params: {
                    next,
                    reportType,
                    todayCalendarDate: currentDate
                }
            }
        );

        yield put({
            type: FETCH_MENSTRUAL_CYCLING_TRACKING_REPORTS_SUCCESS,
            response,
            payloadData: action.payload
        });
    } catch (e) {
        yield put({
            type: FETCH_MENSTRUAL_CYCLING_TRACKING_REPORTS_FAIL
        });
    }
}

// worker
export function* fetchMenstrualCycleEducationalContent() {
    try {
        yield put({
            type: MENSTRUAL_CYCLE_EDUCATIONAL_CONTENT_FETCHING
        });

        const response = yield call(webApi.get, `/web-data/menstrual-cycle-tracking/educational-content.json`, {
            baseURL: '/'
        });

        yield put({
            type: MENSTRUAL_CYCLE_EDUCATIONAL_CONTENT_SUCCESS,
            response
        });
    } catch (e) {
        yield put({
            type: MENSTRUAL_CYCLE_EDUCATIONAL_CONTENT_ERROR
        });
    }
}

export function* saveMenstrualCycleInitialSetup(action) {
    const currentDate = new moment().format(DATE_FORMAT);
    const { payload } = action;
    try {
        yield put({
            type: SAVE_MENSTRUAL_CYCLE_INITIAL_SETUP_START
        });

        if (payload.userSettings) {
            try {
                yield put({
                    type: UPDATE_USER_SETTINGS_UPDATING
                });
                yield call(gcApi.put, `userprofile-service/userprofile/user-settings/`, {
                    id: payload.userSettings.id,
                    userMenstrualCycleSettings: payload.userSettings.userMenstrualCycleSettings
                });

                yield put({
                    type: UPDATE_USER_SETTINGS_SUCCESS,
                    userSettings: action.payload
                });
            } catch (e) {
                yield put({
                    type: UPDATE_USER_SETTINGS_ERROR,
                    userSettings: null
                });
            }
        }

        if (payload.initCycleSetup) {
            yield call(gcApi.post, `/periodichealth-service/menstrualcycle/initCycleSetup`, {
                ...action.payload.initCycleSetup
            });
        }

        yield put({
            type: FETCH_USER_SETTINGS
        });

        yield put({
            type: FETCH_MENSTRUAL_CYCLE_DAILY_VIEW,
            payload: { date: currentDate }
        });

        yield put({
            type: UNSET_MENSTRUAL_CYCLE_INITIAL_SETUP_STEP1
        });
        yield put({
            type: SAVE_MENSTRUAL_CYCLE_INITIAL_SETUP_SUCCESS
        });
        yield put({
            type: OPEN_MCT_INITIAL_SETUP_ALL_SET_MODAL
        });
        yield put({
            type: UNSET_MENSTRUAL_CYCLE_INITIAL_SETUP
        });
    } catch (e) {
        yield put({
            type: SAVE_MENSTRUAL_CYCLE_INITIAL_SETUP_FAIL
        });
    }
}

export function* saveOrConfirmSingleMenstrualCycle(action) {
    const { payload } = action;

    try {
        yield put({
            type: SAVE_OR_CONFIRM_SINGLE_CYCLE_START
        });

        const response = yield call(gcApi.post, `/periodichealth-service/menstrualcycle/${payload.periodStartDate}`, {
            ...payload
        });

        yield put({
            type: SAVE_OR_CONFIRM_SINGLE_CYCLE_END,
            response
        });
    } catch (e) {
        yield put({
            type: SAVE_OR_CONFIRM_SINGLE_CYCLE_FAIL
        });
    }
}

// watcher
export const menstrualCycleTrackingSagas = [
    takeEvery(FETCH_MENSTRUAL_CYCLE_DAILY_VIEW, fetchMenstrualCycleDayView),
    takeEvery(FETCH_MENSTRUAL_CYCLE_SYMPTOMS_ICONS, fetchMenstrualCycleSymptomsIcons),
    takeEvery(UPDATE_USER_MENSTRUAL_CYCLE_SYMPTOMS, updateUserMenstrualCycleSymptoms),
    takeEvery(FETCH_MENSTRUAL_CYCLING_TRACKING_SUMMARY, fetchMenstrualCyclingTrackingSummary),
    takeEvery(FETCH_MENSTRUAL_CYCLING_TRACKING_CALENDAR, fetchMenstrualCyclingTrackingCalendar),
    takeEvery(FETCH_MENSTRUAL_CYCLING_TRACKING_REPORTS, fetchMenstrualCyclingTrackingReports),
    takeEvery(SAVE_MENSTRUAL_DATE_CHANGES, updateMenstrualCycleDates),
    takeEvery(SAVE_MENSTRUAL_DATE_CHANGES_AND_UPDATE_DAY_VIEW_DATA, updateMenstrualCycleDatesAndFetchDayViewData),
    takeEvery(FETCH_MENSTRUAL_CYCLE_EDUCATIONAL_CONTENT, fetchMenstrualCycleEducationalContent),
    takeEvery(SAVE_MENSTRUAL_CYCLE_INITIAL_SETUP, saveMenstrualCycleInitialSetup),
    takeEvery(SAVE_OR_CONFIRM_SINGLE_CYCLE, saveOrConfirmSingleMenstrualCycle)
];
